import { ReactElement } from "react";
import { ButtonSize, Footer as SeibunFooter, TextLink } from "@telusinternationalai/seibun-ui";

import { COMPANY_NAME, CURRENT_YEAR, LIONBRIDGE_AI_URL } from "../../constants";

const footerText = "About AI Data Solutions" + " | " + COMPANY_NAME;

const Footer = ({ className }: { className?: string }): ReactElement => (
  <SeibunFooter
    className={className}
    copyright={{
      year: CURRENT_YEAR,
      company: COMPANY_NAME,
    }}
  >
    <TextLink className="ml-auto" href={LIONBRIDGE_AI_URL} size={ButtonSize.SMALL} target="_blank">
      {footerText}
    </TextLink>
  </SeibunFooter>
);

export default Footer;
